import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.ITemplatesState = { };

const designTypeReducer = (
  state: types.ITemplatesState = defaultState, 
  action: IAction | types.ISetTemplateAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_TEMPLATE: {
      return {...state, templates: (action as types.ISetTemplatesAction).templates};
    }
    case actionTypes.SET_EVERY_TEMPLATE: {
      return {...state, everyTemplates: (action as types.ISetEveryTemplatesAction).everyTemplates};
    }
    case actionTypes.SET_TEMPLATE_INFO: {
      return {...state, template: (action as types.ISetTemplateAction).template};
    }
    case actionTypes.ADD_SUCCESS: {
      return {...state, response: (action as types.IServerSuccessAction).response};
    }
    case actionTypes.SET_SEARCH: {
      return {...state, searches: (action as types.ISetSearchAction).searches};
    }
    case actionTypes.SET_COUNTER: {
      return {...state, counter: (action as types.ISetCounterAction).counter};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
